// Export the Component Definition for use in Contentful Studio
export {ImageCorporateSiteContentfulComponentDefinition} from './imageCorporateSiteContentfulDefinition';
export {ImageCSforAllContentfulComponentDefinition} from './imageCSforAllContentfulDefinition';
export {default} from './Image';
